import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { APP_ROUTES } from '../../constants';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, isSessionExpired, logout } = useAuthStore();
  const sessionExpired = isAuthenticated && isSessionExpired();

  useEffect(() => {
    if (sessionExpired) {
      logout({ reason: 'idle_timeout' });
    }
  }, [logout, sessionExpired]);

  if (isAuthenticated && !sessionExpired) {
    return <Navigate to={APP_ROUTES.HOME} replace />;
  }

  return children;
};

export default PublicRoute;
